import React, { useContext, useEffect, useState } from "react";
import Header from "./Comman/Header";
import { OnmaxContext } from "../OnmaxContext";
import axios from "axios";
import Pagination from "./Comman/Pagination";

export default function Ledger() {
  const { account } = useContext(OnmaxContext);
  const [data, setdata] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);

  const getData = async () => {
    if (!account) {
      return;
    }
    setisLoading(true);

    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "statement",
        submethod: "getbyid",
        // address: account,
        address: "0x5b38da6a701c568545dcfcb03fcb875f56beddc4",
        key: process.env.REACT_APP_KEY,
        page: currentPage,
        pageSize: pageSize,
      })
      .then((res) => {
        console.log("getUserStatement", res.data);
        // var dedata = decryptData(res.data);
        setisLoading(false);

        if (res.data.error) {
          return "";
        }
        setdata(res.data.data);
        setPages(Math.ceil(res.data.dataLength / pageSize));

      });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getData();
  }, [account, pageSize, currentPage]);

  return (
    <>
      <div className="body-bg">
        <Header />
        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12">

                <div className="db-profile-card mb-5">
                  <div className="db-sec-hdr">
                    <div className="db-sec-dot"></div>
                    <div className="db-sec-title">Ledger</div>
                  </div>

                  <div className="card-body p-0 mt-3">
                    <div className="table-responsive">
                      <table className="table table-dashboard-premium align-middle mb-0" style={{ minWidth: '900px' }}>
                        <thead className="text-uppercase small">
                          <tr>
                            <th scope="col" className="ps-4 py-3">Sr.</th>
                            <th scope="col" className="py-3">Date</th>
                            <th scope="col" className="py-3">Description</th>
                            <th scope="col" className="py-3">Credit</th>
                            <th scope="col" className="py-3">Debit</th>
                            <th scope="col" className="py-3">Balance</th>
                            <th scope="col" className="pe-4 py-3 text-end">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading && !data.length ? (
                            <tr>
                              <td colSpan="7" className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                  <span className="visually-hidden">Loading...</span>
                                </div>
                              </td>
                            </tr>
                          ) : !data.length ? (
                            <tr>
                              <td colSpan="7" className="text-center py-5 text-slate-400">
                                <p className="mb-0">No data found</p>
                              </td>
                            </tr>
                          ) : (
                            data.map((ele, i) => {
                              const index = currentPage * pageSize - pageSize + (i + 1);
                              return (
                                <tr key={i} className="table-tr-premium">
                                  <td className="ps-4">
                                    <span className="text-slate-400 small">{index}</span>
                                  </td>
                                  <td>
                                    <span className="text-white-custom small">{ele.datetime}</span>
                                  </td>
                                  <td>
                                    <span className="text-white-custom fw-semibold">{ele.description}</span>
                                  </td>
                                  <td>
                                    <span className="fw-bold text-success">
                                      {ele.status === 0 ? `$ ${ele.amount}` : "-"}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="fw-bold text-danger">
                                      {ele.status === 1 ? `$ ${ele.amount}` : "-"}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="fw-bold text-white-custom text-nowrap">$ {ele.balance}</span>
                                  </td>
                                  <td className="pe-4 text-end">
                                    <div className="d-flex flex-column align-items-end">
                                      {ele.flushed && <span className="text-danger small fw-bold">Flushed</span>}
                                      {ele.gracing && <span className="text-warning small fw-bold">Gracing</span>}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="card-footer bg-transparent border-top border-secondary border-opacity-10 p-4">
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      pages={pages}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
